import { BOOKING_REQUESTS_PAGE_SIZE, CREATED, CREATOR, FREIGHT_PARTNER } from 'actions';
import {ActionTopHeader, RequestTabs } from 'components';
import { BookingRequestContext, HomeContext, ModalContext } from 'contexts';
import React, { useContext, useEffect, useState } from 'react';
import './index.scss'

const BookingRequest = ({shipmentId}) => {
    const { bookingRequestTab, setBookingRequestTab, setBrType, shipmentIdBooking } = useContext(HomeContext);
    const { doGetBookingRequests } = useContext(BookingRequestContext);
    const { setRequestFilter } = useContext(ModalContext);

    const [selectedTab, setSelectedTab] = useState(CREATED);
    const [searchParams, setSearchParams] = useState({
        page: 0,
        limit: BOOKING_REQUESTS_PAGE_SIZE,
        shipmentId : shipmentId,
        isSearching: true
    });

    /*eslint-disable */
    useEffect(() => {
        setSelectedTab(bookingRequestTab);
        setBrType(bookingRequestTab === CREATED ? CREATOR : FREIGHT_PARTNER);
    }, [bookingRequestTab])
    /*eslint-enable */

    const onFilterApplied = params => {
        const newParams = params || searchParams;

        if (selectedTab) {
            doGetBookingRequests({
                ...newParams,
                tab: selectedTab,
                shipmentId: shipmentIdBooking ? shipmentIdBooking : '',
            }, () => {
                if (!params) setRequestFilter(false);
            });   
        }
    }
    
    return (
        <div className="tr__booking-request page-box ">
            <ActionTopHeader
                title="Booking Request"
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                onFilterApplied={onFilterApplied}
                onClearFilters={onFilterApplied}
                selectedTab={selectedTab}
            />

            <RequestTabs
                shipmentId={shipmentId}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                selectedTab={selectedTab}
                setSelectedTab={setBookingRequestTab}
            />
        </div>
    )
};

export default BookingRequest;
